const requireContext = require.context('.', false, /\.js$/)
let services = {}

requireContext.keys().forEach(fileName => {
  if (fileName === './index.js' || fileName === './base.js') return
  services = {...services, ...requireContext(fileName).default}
})

export default services



// WEBPACK FOOTER //
// ./src/services/index.js